/* global axios */
import ApiClient from '../ApiClient';

class AiBotPersonaTemplatesAPI extends ApiClient {
  constructor(botId) {
    super(`agent_bots/${botId}/persona_templates`, { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }
}

export default AiBotPersonaTemplatesAPI;
